export default __webpack_public_path__ + "static/media/sh-logo-icon.5baa7fdf.svg";